import { getField, updateField } from 'vuex-map-fields'
import Line from './line'
import api from '../api/api'
// import {bus} from "@/main";

export const namespaced = true

let baseUrl = '/head_lines/'

const line = new Line(baseUrl)

const getDefaultState = () => {
  return {
    ...structuredClone(line.state),
    color: 'navy',
    dash: 'dash',
    name: 'Hydraulic Head Line',
    storeNamespace: 'headLine',
    importFromHydraulicHeadLoading: false,
    importFromHydraulicHeadDialog: false
  }
}

export const state = getDefaultState()

export const mutations = {
  ...line.mutations,
  updateField,
  TOGGLE_IMPORT_FROM_HYDRAULIC_HEAD_LOADING(state) {
    state.importFromHydraulicHeadLoading = !state.importFromHydraulicHeadLoading
  },
  TOGGLE_IMPORT_FROM_HYDRAULIC_HEAD_DIALOG(state) {
    state.importFromHydraulicHeadDialog = !state.importFromHydraulicHeadDialog
  }
}

export const actions = {
  ...line.actions,
  async generate(context) {
    context.commit('TOGGLE_GENERATE_LOADING')
    const id = context.rootGetters['stabSchematisationStage/currentStabSchematisationStageId']
    const multipleHeadLineNumber =
      context.rootGetters['multipleHeadLine/getCurrentMultipleHeadLineNumber']
    const riverWaterLevel = context.rootGetters['multipleHeadLine/getRiverWaterLevel']
    const polderWaterLevel = context.rootGetters['multipleHeadLine/getPolderWaterLevel']
    const currentMultipleHeadLine = context.rootState.multipleHeadLine.currentItem
    const url = baseUrl + id + '/generate/'
    try {
      const response = await api.post(url, {
        number: multipleHeadLineNumber,
        river_water_level: riverWaterLevel,
        polder_water_level: polderWaterLevel,
        properties: { multiple_head_line: currentMultipleHeadLine.id }
      })
      await context.dispatch('replaceLine', response)
      context.commit('TOGGLE_GENERATE_LOADING')
    } catch (e) {
      console.log(e)
      context.commit('TOGGLE_GENERATE_LOADING')
      return false
    }
    return true
  },
  toggleImportFromHydraulicHeadDialog({ commit }) {
    commit('TOGGLE_IMPORT_FROM_HYDRAULIC_HEAD_DIALOG')
  },
  updateOverviewHeadline2({ commit, state }, { id, enabled }) {
    const headline2 = state.itemsOverview.find((item) => item.id === id)
    if (headline2) {
      commit('SET_NESTED_PARAMETER', {
        item: headline2,
        parameter: 'properties.enabled',
        value: enabled
      })
    }
  },
  async importFromHydraulicHead({ rootGetters, commit, dispatch, rootState }) {
    const schematistaionStageId =
      rootGetters['stabSchematisationStage/currentStabSchematisationStageId']
    const multipleHeadLineNumber = rootGetters['multipleHeadLine/getCurrentMultipleHeadLineNumber']
    const url = `${baseUrl}${schematistaionStageId}/import/`
    const currentMultipleHeadLine = rootState.multipleHeadLine.currentItem
    try {
      commit('TOGGLE_IMPORT_FROM_HYDRAULIC_HEAD_LOADING')
      const response = await api.post(url, {
        number: multipleHeadLineNumber,
        properties: { multiple_head_line: currentMultipleHeadLine.id }
      })
      const topoProfileId = rootGetters['stabSchematisationStage/currentTopoProfileId']
      await dispatch('topoProfilePoint/fetchItems', topoProfileId, {
        root: true
      })
      commit('REPLACE_LINE', response.data)
      commit('SET_DELETED_ITEM', {
        ...structuredClone(response.data)
      })
      commit('SET_COORDINATE')
      commit('SET_DELETED_COORDINATE')
    } finally {
      commit('TOGGLE_IMPORT_FROM_HYDRAULIC_HEAD_LOADING')
    }
  }
}

export const getters = {
  ...line.getters,
  getField
}
